import { AvatarGroup, Checkbox, FormControlLabel, FormGroup, IconButton, Modal, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Typography } from '@mui/material';
import axios from '../../util/Axios';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TestDetails from '../../components/TestDetails/TestDetails';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import { EditInformedConsentNumber } from './EditInformedConsentNumber';
import { useSelector } from 'react-redux';
import { StatusAvatar } from '../../components/TestStatuses/StatusAvatar';

export default function InformedConsents() {
  const [openDetails, setOpenDetails] = useState(false);
  const [openedTestId, setOpenedTestId] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const isLegalAdmin = useSelector((state) => state.GlobalReducer.loggedUser?.adminRole === 'LEGAL_TEAM');

  const [tests, setTests] = useState([]);

  const [shouldRefresh, setShouldRefresh] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(50);

  const [pageParam, setPageParam] = useState(0);

  const [page, setPage] = useState({ number: 0, count: 0 });

  const location = useLocation();

  const [selectedTestId, setSelectedTestId] = useState(null);

  const filterToolbarStyle = { display: 'flex', justifyContent: 'flex-end' };

  const [showOnlyMissing, setShowOnlyMissing] = useState(true);

  const handleShowOnlyMissing = (event) => {
    setShowOnlyMissing(event.target.checked);
  };

  useEffect(() => {
    const showOnlyMissingParam = showOnlyMissing ? '&showOnlyMissing=true' : '';
    axios(`/strokeTests/details/informedConsents?${showOnlyMissingParam}&sort=doctor.hospital,doctor.name,createdAt&size=${rowsPerPage}&page=${pageParam}`).then((response) => {
      const tests = response.data.content;
      setTests(tests);
      setPage({ number: response.data.number, count: response.data.totalElements });
      setShouldRefresh(false);
    });
  }, [rowsPerPage, pageParam, shouldRefresh, location.pathname, showOnlyMissing]);

  const handleOpenDetails = (testId) => {
    setOpenedTestId(testId);
    setOpenDetails(true);
    setSelectedTestId(testId);
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
    setOpenedTestId(null);
    setShouldRefresh(true);
  };

  const handleOpenEdit = (testId) => {
    setSelectedTestId(testId);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setShouldRefresh(true);
  };

  return (
    <>
      <Typography
        component="h1"
        sx={{
          textAlign: 'center',
          fontSize: '2em',
          width: '100%',
        }}
      >
        Informed Consents
      </Typography>
      <Typography
        variant="subtitle1"
        component="body"
        sx={{
          textAlign: 'center',
          width: '100%',
        }}
      ></Typography>

      <div style={filterToolbarStyle}>
        <FormGroup>
          <FormControlLabel control={<Checkbox checked={showOnlyMissing} onChange={handleShowOnlyMissing} />} label="Show only tests with missing consent number" />
        </FormGroup>
      </div>
      <Table size="small" aria-label="purchases">
        <TableHead>
          <TableRow>
            <TableCell>Hospital</TableCell>
            <TableCell>Doctor</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Patient</TableCell>
            <TableCell>Informed consent number</TableCell>
            <TableCell>Test Status</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tests.map((test) => (
            <TableRow key={test.uuid} sx={test.uuid === selectedTestId ? { backgroundColor: '#e3f2fd' } : {}}>
              <TableCell>{test.doctor?.hospital}</TableCell>
              <TableCell>{test.doctor?.name}</TableCell>
              <TableCell>{test.createdAt.split('.')[0].replace('T', ' ')}</TableCell>
              <TableCell>{test.patient?.name}</TableCell>
              <TableCell>
                {test.informedConsentCode}{' '}
                <IconButton onClick={() => handleOpenEdit(test.uuid)}>
                  <Tooltip title="Edit">
                    <EditIcon />
                  </Tooltip>
                </IconButton>
              </TableCell>
              <TableCell>
                <AvatarGroup>
                  <StatusAvatar status={test.faceStatus} type="face" />
                  <StatusAvatar status={test.speechStatus} type="speech" />
                  <StatusAvatar status={test.armsStatus} type="arms" />
                  <StatusAvatar status={test.neurologicalExaminationStatus} type="neurologicalExamination" />
                </AvatarGroup>
              </TableCell>
              <TableCell>
                {isLegalAdmin ? (
                  ''
                ) : (
                  <IconButton onClick={() => handleOpenDetails(test.uuid)}>
                    <Tooltip title="View details">
                      <InfoIcon />
                    </Tooltip>
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination rowsPerPageOptions={[5, 10, 25, 50, 100, 1000]} rowsPerPage={rowsPerPage} onRowsPerPageChange={(e) => setRowsPerPage(e.target.value)} count={page.count} page={page.number} onPageChange={(e, newPage) => setPageParam(newPage)} />
          </TableRow>
        </TableFooter>
      </Table>
      <Modal open={openDetails} onClose={handleCloseDetails}>
        <TestDetails id={openedTestId} onClose={handleCloseDetails}></TestDetails>
      </Modal>
      <EditInformedConsentNumber open={openEdit} testId={selectedTestId} informedConsentNo={tests.find((t) => t.uuid === openedTestId)?.informedConsentCode} handleClose={handleCloseEdit} />
    </>
  );
}
